<template>
    <v-menu v-model="menu" offset-y :close-on-content-click="false" :disabled="disabled" min-width="210" max-width="210">
        <template v-slot:activator="{ on, attrs }">
            <button type="button" class="hour-btn" :class="{ 'hour-btn--disabled': disabled }" v-bind="attrs" v-on="on">
                {{ label }}
            </button>
        </template>
        <div class="hour-pop">
            <div class="hour-dial">
                <svg class="hour-hand" :viewBox="`0 0 ${dial} ${dial}`">
                    <line :x1="center" :y1="center" :x2="hand.x" :y2="hand.y" />
                </svg>
                <div class="hour-center"></div>
                <button v-for="h in 24" :key="h" type="button" class="hour-num"
                    :class="{ 'hour-num--selected': h - 1 === value }" :style="numStyle(h - 1)" @click="pick(h - 1)">
                    {{ h - 1 }}
                </button>
            </div>
        </div>
    </v-menu>
</template>

<script>
const DIAL = 190

const polar = (radius, hour) => {
    const rad = (hour * 15 - 90) * Math.PI / 180
    return { x: DIAL / 2 + radius * Math.cos(rad), y: DIAL / 2 + radius * Math.sin(rad) }
}

export default {
    name: 'HourClockPicker',
    props: {
        value: {
            type: Number,
            default: 20,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            menu: false,
            dial: DIAL,
            center: DIAL / 2,
        }
    },
    computed: {
        label(vm = this) {
            return `${String(vm.value).padStart(2, '0')}:00`
        },
        hand(vm = this) {
            return polar(60, vm.value)
        },
    },
    methods: {
        numStyle(hour) {
            const p = polar(78, hour)
            return { left: `${p.x}px`, top: `${p.y}px` }
        },
        pick(hour) {
            this.menu = false
            this.$emit('change', hour)
        },
    },
}
</script>

<style scoped>
.hour-btn {
    height: 32px;
    min-width: 64px;
    padding: 0 12px;
    border-radius: 20px;
    border: 1px solid var(--v-outline2-base);
    background: var(--v-surface2-base);
    color: var(--v-txtPrimary-base);
    font-size: 13px;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    cursor: pointer;
    transition: border-color .15s, color .15s;
}

.hour-btn:hover {
    border-color: var(--v-accent-base);
    color: var(--v-accent-base);
}

.hour-btn--disabled {
    opacity: .45;
    pointer-events: none;
}

.hour-pop {
    padding: 10px;
    background: var(--v-surface-base);
    border: 1px solid var(--v-outline-base);
    border-radius: 12px;
}

.hour-dial {
    position: relative;
    width: 190px;
    height: 190px;
    border-radius: 50%;
    background: var(--v-surface2-base);
}

.hour-hand {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

.hour-hand line {
    stroke: var(--v-accent-base);
    stroke-width: 2;
}

.hour-center {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 8px;
    height: 8px;
    margin: -4px 0 0 -4px;
    border-radius: 50%;
    background: var(--v-accent-base);
}

.hour-num {
    position: absolute;
    width: 26px;
    height: 26px;
    margin: -13px 0 0 -13px;
    border-radius: 50%;
    font-size: 11px;
    font-weight: 600;
    color: var(--v-txtSecondary-base);
    background: none;
    border: none;
    cursor: pointer;
    transition: background .15s, color .15s;
}

.hour-num:hover {
    background: rgba(51, 153, 153, .15);
    color: var(--v-txtPrimary-base);
}

.hour-num--selected {
    background: var(--v-accent-base) !important;
    color: #fff !important;
}
</style>
